/** @jsxImportSource @emotion/react */
import {useCallback, useEffect, useState} from 'react';
import {MenuEntry} from '../layout/menu/menuEntry';
import {unwrap} from '../language/funcOrValue';
import FloatingMenu from '../layout/menu/FloatingMenu';
import {LAYER} from '../layout/zIndex';
import {css, SerializedStyles} from '@emotion/react';
import solidArrow from '../assets/icons/downArrowSolid.svg';
import { getResource } from '../language/resources/getResource';
import { IAppState } from '../core/redux/IAppState';
import { useSelector } from 'react-redux';

const floatingMenuArrow = css`
  /* Odd dimensions size image to the height of a lower-case letter @ 2rem */
  width: 19px;
  height: 9.5px;
padding: 5px 5px 0;
`;

type Props = {
  onSortChange: (option: string, sortAsc: boolean) => void;
  defaultSort?: string;
  rootCss?: SerializedStyles;
};

/**
 * SortByMenu
 * A dropdown menu of sorting options for guest results.
 *
 * PureComponent: true
 * Connected to redux: false
 */
export const SortByMenu = (props: Props) => {
  const resources = useSelector((state: IAppState) => state.locale);
  const [selected, setSelected] = useState(getResource(resources, 'GUEST_SORT_RELEVANCE'));

  const { onSortChange } = props;

  const handleSortChange = useCallback(
    (title: string, prop: string, sortAsc: boolean) => {
      setSelected(title);
      onSortChange?.(prop, sortAsc);
    },
    [onSortChange]
  );

  const makeMenuItems = useCallback((): MenuEntry[] => [
    {
      key:     'sortRelevance',
      text:    getResource(resources, 'GUEST_SORT_RELEVANCE'),
      title:   getResource(resources, 'GUEST_SORT_RELEVANCE'),
      onClick: () => handleSortChange(getResource(resources, 'GUEST_SORT_RELEVANCE'), '', false),
    }, {
      key:     'lastNameAsc',
      text:    getResource(resources, 'GUEST_SORT_LAST_NAME_A_Z'),
      title:   getResource(resources, 'GUEST_SORT_LAST_NAME_A_Z'),
      onClick: () => handleSortChange(getResource(resources, 'GUEST_SORT_LAST_NAME_A_Z'), 'lastName', true),
    }, {
      key:     'lastNameDesc',
      text:    getResource(resources, 'GUEST_SORT_LAST_NAME_Z_A'),
      title:   getResource(resources, 'GUEST_SORT_LAST_NAME_Z_A'),
      onClick: () => handleSortChange(getResource(resources, 'GUEST_SORT_LAST_NAME_Z_A'), 'lastName', false),
    }, {
      key:     'dobAsc',
      text:    getResource(resources, 'GUEST_SORT_AGE_0_100'),
      title:   getResource(resources, 'GUEST_SORT_AGE_0_100'),
      onClick: () => handleSortChange(getResource(resources, 'GUEST_SORT_AGE_0_100'), 'dob', true),
    }, {
      key:     'dobDesc',
      text:    getResource(resources, 'GUEST_SORT_AGE_100_0'),
      title:   getResource(resources, 'GUEST_SORT_AGE_100_0'),
      onClick: () => handleSortChange(getResource(resources, 'GUEST_SORT_AGE_100_0'), 'dob', false),
    },
  ], [resources, handleSortChange]);

  const getMenuTitle = (isOpen: boolean) => isOpen ? getResource(resources, 'GUEST_SORT_MENU_CLOSE') : getResource(resources, 'GUEST_SORT_MENU_OPEN');

  useEffect(() => {
      if (props.defaultSort) {
        setSelected(unwrap(makeMenuItems().find(entry => entry.key === props.defaultSort)?.title || getResource(resources, 'GUEST_SORT_RELEVANCE')));
      }


  }, [makeMenuItems, props.defaultSort, resources])

  return (
    <FloatingMenu
      menuZIndex={LAYER.THREE.FLOATING_CONTENT}
      menuItems={makeMenuItems()}
      menuTitle={getMenuTitle}
      menuCss={css`width: 200px;`}
    >
      <span>{selected}&nbsp;</span>
      <img
        alt='arrow'
        src={solidArrow}
        css={floatingMenuArrow}
      />
    </FloatingMenu>
  );

}